import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'

import App from './App.vue'
import store from './store/store'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheck,
  faEnvelope,
  faPhoneAlt,
  faGlobeEurope,
  faPlane,
  faPlaneDeparture,
  faPlaneSlash,
  faClock
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import './styles/site.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'

library.add(faCheck)
library.add(faEnvelope)
library.add(faPhoneAlt)
library.add(faGlobeEurope)
library.add(faPlane)
library.add(faPlaneDeparture)
library.add(faPlaneSlash)
library.add(faClock)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
Vue.use(Vuelidate)

Vue.config.productionTip = false

// create an event bus for events that aren't simply child -> parent
export const eventBus = new Vue({
  methods: {
    selectProduct(dayNo, productType) {
      this.$emit('selectProductClicked', dayNo, productType)
    },
    addProduct(productId, productTime) {
      this.$emit('addProductClicked', productId, productTime)
    }
  }
})

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
